import React, {PureComponent, Suspense} from 'react'
import {HashRouter, Route, Switch} from 'react-router-dom'
import {I18nextProvider} from 'react-i18next'
import {NotificationsProvider} from 'context/NotificationsContext'
import {InteractionContext, InteractionProvider} from 'context/InteractionContext'
import {UserProvider} from 'context/UserContext'
import Shell from 'components/shell'
import ScrollToTop from 'components/ScrollToTop'
import i18n from 'i18n-client'
import VirtualPageTracking from '../../VirtualPageTracking'

import {
  ActivationPage,
  ForgetForm,
  LoginForm,
  LogisterPage,
  RegistrationPage,
  ResetPasswordForm,
} from './HostedLoginAsyncRoutes'

class HostedLogin extends PureComponent {
  render() {
    return (
      <I18nextProvider i18n={i18n}>
        <InteractionProvider>
          <NotificationsProvider landing>
            <HashRouter>
              <UserProvider>
                <VirtualPageTracking />
                <Shell>
                  <Suspense fallback="">
                    <ScrollToTop>
                      <Switch>
                        <Route exec path="/activate" component={ActivationPage} />
                        <Route exec path="/forget" component={ForgetForm} />
                        <Route exec path="/resetpassword" component={ResetPasswordForm} />
                        <Route exec path="/login" component={LoginForm} />
                        <Route exec path="/register" component={RegistrationPage} />

                        <Route
                          render={() => (
                            <InteractionContext.Consumer>
                              {({loginCase, interactionToken}) => (
                                <LogisterPage loginCase={loginCase} interactionToken={interactionToken} />
                              )}
                            </InteractionContext.Consumer>
                          )}
                        />
                      </Switch>
                    </ScrollToTop>
                  </Suspense>
                </Shell>
              </UserProvider>
            </HashRouter>
          </NotificationsProvider>
        </InteractionProvider>
      </I18nextProvider>
    )
  }
}

export {HostedLogin as PureHostedLogin}

export default HostedLogin
